import React from "react";

/**
 *select input component
 * @param {string} labelName
 * @param {array} options
 * @param {function} onChange
 * @returns
 */
const InputSelect = ({ labelName, options, onChange }) => {
  return (
    <label htmlFor="">
      <span className="block text-left font-nunito text-xs font-thin text-black/70">
        {labelName}
      </span>
      <select
        onChange={onChange}
        className="animate placeholder:text-back/50 text-gray-700 peer mt-0.5 w-full rounded border border-secondary bg-white px-2 py-1.5 text-xs text-black/70 placeholder:text-xs focus:border-primary focus:outline-none md:py-2  md:text-xs"
      >
        <option value="">-----</option>
        {options?.map((option, index) => {
          return (
            <option key={index} value={option.value}>
              {option.label}
            </option>
          );
        })}
      </select>
    </label>
  );
};

export default InputSelect;
